export function getSafeReturnTo(value: unknown) {
  const rawValue = Array.isArray(value) ? value[0] : value;
  const returnTo = String(rawValue ?? "").trim();

  if (!returnTo.startsWith("/") || returnTo.startsWith("//")) return "";
  if (returnTo.includes("\n") || returnTo.includes("\r")) return "";

  return returnTo;
}

export function getReturnButtonLabel(returnTo: string) {
  if (!returnTo) return "Back Home";
  if (returnTo === "/directory" || returnTo === "/(tabs)/directory") {
    return "Back to Directory";
  }
  if (/^\/p\/[^/]+/.test(returnTo)) return "Back to Business Profile";

  return "Back";
}

export function getReturnToUrl(returnTo: string) {
  if (!returnTo) return "Not provided";

  if (typeof window !== "undefined" && window.location?.origin) {
    return `${window.location.origin}${returnTo}`;
  }

  return returnTo;
}
